import { render, staticRenderFns } from "./DeviceMonitor.vue?vue&type=template&id=16b0aca6&scoped=true&"
import script from "./DeviceMonitor.vue?vue&type=script&lang=js&"
export * from "./DeviceMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMonitor.vue?vue&type=style&index=0&id=16b0aca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0aca6",
  null
  
)

export default component.exports